import React from 'react';
import { Card, Spinner } from 'ui';
import useFetch from 'components/shared/hooks/useFetch';
import { BlankSlate } from 'components/_shared/blank_slate';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';

const formatDate = date => moment(date).format(DateFormat.LONG_AT_TIME);

const CompletionsByUserTable = ({ question, lessonId, groupId }) => {
  const completionsByUserURL =
    routes.LESSON_OVERVIEW.CONVERSATION_COMPLETIONS_BY_USER(
      lessonId,
      question.id,
      groupId,
    );
  const { data, initialLoading } = useFetch(completionsByUserURL);

  return (
    <>
      <h3 className="ff-ss fw-b ws-pr mt-48 mb-32">
        {t('lesson_performance.conversations.completions_by_learner_heading')}
      </h3>
      {initialLoading && <Spinner />}
      {!initialLoading && (
        <Card className="bs-n">
          <Card.Content>
            {data.length === 0 && (
              <BlankSlate align="left" className="fz-lg">
                {t(
                  'practice.on_demand_practice.overview.attempts_table.blank_slate_message',
                )}
              </BlankSlate>
            )}
            {data.length > 0 && (
              <table
                className="DataTable Table tablesaw tablesaw-stack w-fill"
                data-tablesaw-mode="stack"
              >
                <thead>
                  <tr>
                    <th name="userName" className="DataTable-name">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.name_header',
                        )}
                      </span>
                    </th>
                    <th name="lastCompletedAt">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.last_completed_header',
                        )}
                      </span>
                    </th>
                    <th name="count">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.count_header',
                        )}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(completion => (
                    <tr key={completion.id}>
                      <td className="DataTable-name">
                        <span className="pl-16">{completion.userName}</span>
                      </td>
                      <td>
                        <time className="pl-16">
                          {formatDate(completion.lastCompletedAt)}
                        </time>
                      </td>
                      <td>
                        <span className="pl-16">
                          {completion.completionsCount}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Content>
        </Card>
      )}
    </>
  );
};

export default CompletionsByUserTable;
